import { Alignments } from '@mlb/react-patterns/v4/components/Table/table.types.ts';
const { LEFT, RIGHT, CENTER } = Alignments;

export const dictKeys = {
    R: 'labelBrief_h_r',
    H: 'labelBrief_h_h',
    LOB: 'labelBrief_lob',
    OPS: 'labelBrief_ops',
    AVG: 'labelBrief_h_avg',
    HR: 'labelBrief_h_hr',
    ERA: 'labelBrief_era',
    IP: 'labelBrief_ip',
    ER: 'labelBrief_er',
    BB: 'labelBrief_h_bb',
    SO: 'labelBrief_h_so',
    K: 'labelBrief_h_k',
    pitcherK: 'labelBrief_p_k',
    AB: 'labelBrief_ab',
    batters: 'box_batters',
    pitchers: 'box_pitchers',
    B: 'labelBrief_batSide',
    POS: 'labelBrief_pos',
    T: 'labelBrief_pitchHand',
    RBI: 'labelBrief_rbi',
    SB: 'labelBrief_h_sb'
};

const columnsDataFieldsDef = {
    label: 'label',
    atBats: 'atBats',
    runs: 'runs',
    hits: 'hits',
    rbi: 'rbi',
    baseOnBalls: 'baseOnBalls',
    strikeOuts: 'strikeOuts',
    leftOnBase: 'leftOnBase',
    ops: 'ops',
    inningsPitched: 'inningsPitched',
    earnedRuns: 'earnedRuns',
    homeRuns: 'homeRuns',
    era: 'era',
    avg: 'avg',
    gamesPlayed: 'gamesPlayed',
    pos: 'position',
    batSideCode: 'batSideCode',
    pitchHand: 'pitchHand',
    stolenBases: 'stolenBases'
};

const headers = {
    batting: [
        {
            content: 'batters',
            dataField: columnsDataFieldsDef.label,
            fixedWidth: '20%',
            alignment: LEFT
        },
        {
            content: 'AB',
            dataField: columnsDataFieldsDef.atBats,
            fixedWidth: '8%',
            alignment: CENTER
        },
        {
            content: 'R',
            dataField: columnsDataFieldsDef.runs,
            fixedWidth: '8%',
            alignment: CENTER
        },
        {
            content: 'H',
            dataField: columnsDataFieldsDef.hits,
            fixedWidth: '8%',
            alignment: CENTER
        },
        {
            content: 'RBI',
            dataField: columnsDataFieldsDef.rbi,
            fixedWidth: '8%',
            alignment: CENTER

        },
        {
            content: 'BB',
            dataField: columnsDataFieldsDef.baseOnBalls,
            fixedWidth: '8%',
            alignment: CENTER
        },
        {
            content: 'K',
            dataField: columnsDataFieldsDef.strikeOuts,
            fixedWidth: '8%',
            alignment: CENTER
        },
        {
            content: 'AVG',
            dataField: columnsDataFieldsDef.avg,
            fixedWidth: '14%',
            alignment: CENTER
        },
        {
            content: 'OPS',
            dataField: columnsDataFieldsDef.ops,
            fixedWidth: '14%',
            alignment: CENTER
        }
    ],
    pitching: [
        {
            content: 'pitchers',
            dataField: columnsDataFieldsDef.label,
            fixedWidth: '34%',
            alignment: LEFT
        },
        {
            content: 'IP',
            dataField: columnsDataFieldsDef.inningsPitched,
            fixedWidth: '9%',
            alignment: CENTER
        },
        {
            content: 'H',
            dataField: columnsDataFieldsDef.hits,
            fixedWidth: '7%',
            alignment: CENTER
        },
        {
            content: 'R',
            dataField: columnsDataFieldsDef.runs,
            fixedWidth: '7%',
            alignment: CENTER
        },
        {
            content: 'ER',
            dataField: columnsDataFieldsDef.earnedRuns,
            fixedWidth: '8%',
            alignment: CENTER
        },
        {
            content: 'BB',
            dataField: columnsDataFieldsDef.baseOnBalls,
            fixedWidth: '8%',
            alignment: CENTER
        },
        {
            content: 'pitcherK',
            dataField: columnsDataFieldsDef.strikeOuts,
            fixedWidth: '7%',
            alignment: CENTER
        },
        {
            content: 'HR',
            dataField: columnsDataFieldsDef.homeRuns,
            fixedWidth: '9%',
            alignment: CENTER
        },
        {
            content: 'ERA',
            dataField: columnsDataFieldsDef.era,
            fixedWidth: '11%',
            alignment: CENTER
        }
    ],
    bench: [
        {
            content: 'bench',
            dataField: columnsDataFieldsDef.label,
            fixedWidth: '34%',
            alignment: LEFT,
            pinned: true
        },
        {
            content: 'B',
            dataField: columnsDataFieldsDef.batSideCode,
            alignment: CENTER
        },
        {
            content: 'POS',
            dataField: columnsDataFieldsDef.pos,
            alignment: CENTER
        },
        {
            content: 'AVG',
            dataField: columnsDataFieldsDef.avg,
            alignment: CENTER
        },
        {
            content: 'G',
            dataField: columnsDataFieldsDef.gamesPlayed,
            alignment: CENTER

        },
        {
            content: 'R',
            dataField: columnsDataFieldsDef.runs,
            alignment: CENTER
        },
        {
            content: 'H',
            dataField: columnsDataFieldsDef.hits,
            alignment: CENTER
        },
        {
            content: 'HR',
            dataField: columnsDataFieldsDef.homeRuns,
            alignment: CENTER
        },
        {
            content: 'RBI',
            dataField: columnsDataFieldsDef.rbi,
            alignment: CENTER
        },
        {
            content: 'SB',
            dataField: columnsDataFieldsDef.stolenBases,
            alignment: CENTER
        }
    ],
    bullpen: [
        {
            content: 'bullpen',
            dataField: columnsDataFieldsDef.label,
            fixedWidth: '32%',
            alignment: LEFT,
            pinned: true
        },
        {
            content: 'T',
            dataField: columnsDataFieldsDef.pitchHand,
            fixedWidth: '15%',
            alignment: CENTER
        },
        {
            content: 'ERA',
            dataField: columnsDataFieldsDef.era,
            fixedWidth: '20%',
            alignment: CENTER
        },
        {
            content: 'IP',
            dataField: columnsDataFieldsDef.inningsPitched,
            fixedWidth: '20%',
            alignment: CENTER
        },
        {
            content: 'H',
            dataField: columnsDataFieldsDef.hits,
            fixedWidth: '15%',
            alignment: CENTER
        },
        {
            content: 'BB',
            dataField: columnsDataFieldsDef.baseOnBalls,
            fixedWidth: '15%',
            alignment: CENTER
        },
        {
            content: 'pitcherK',
            dataField: columnsDataFieldsDef.strikeOuts,
            fixedWidth: '15%',
            alignment: CENTER
        }
    ]
};

export default headers;
